var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        visible: _vm.visible,
        maskClosable: false,
        title: "国际支付",
        width: "1000px",
        zIndex: 2000
      },
      on: {
        cancel: function($event) {
          return _vm.$emit("cancel")
        },
        ok: function($event) {
          return _vm.$emit("ok")
        }
      }
    },
    [
      _c("iframe", {
        ref: "paymentIframe",
        staticClass: "payment-iframe",
        attrs: { src: _vm.httpsPay + "/client/cashieret?" + _vm.payParams }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f5ab7a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f5ab7a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./xcloud-client-components-web/module/components/intlPay/index.vue
// module id = null
// module chunks = 